import Menu from 'records/Menu';
import Base from 'records/Base';

import {
  MENU_ASYNC_ACTION_START,
  MENU_ASYNC_ACTION_ERROR,
  MENU_ASYNC_UPDATE_ACTION_SUCCESS,
  MENU_UPDATE_ACTION_SUCCESS,
  MENU_ARCHIVE_ACTION_SUCCESS,
  MENU_DUPLICATE_ACTION_SUCCESS,
  MENU_RESET_STATE,
  MENU_ASYNC_UPDATE_PARTIAL_ACTION_SUCCESS,
} from 'actions/menu';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new Menu(),
});

const actionsMap = {
  [MENU_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [MENU_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [MENU_ASYNC_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new Menu(action.data),
    });
  },
  [MENU_ASYNC_UPDATE_PARTIAL_ACTION_SUCCESS]: (state, action) => {
    const originalMenu = state.data;
    const newMenu = originalMenu.merge({ ...action.data, });
    return new Base({
      loading: false,
      errorMessage: null,
      data: newMenu,
    });
  },
  [MENU_UPDATE_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [MENU_ARCHIVE_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
    });
  },
  [MENU_DUPLICATE_ACTION_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
    });
  },
  [MENU_RESET_STATE]: () => {
    return initialState;
  },
};

export default function menu(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
